<template>
    <v-btn disabled x-large class="w-100 px-16 px-lg-20 justify-space-between" rounded elevation="0" :class="{ 'grey-c4': isClosed || isApproved, 'primary--light': !isClosed && !isApproved }">
        <span class="grey-dark--text">{{ time }}시({{ isClosed || isApproved ? "마감" : "승인대기" }})</span>
    </v-btn>
    <!-- <div :class="{ 'grey lighten-4 grey-8f--text': isClosed || isApproved, 'green lighten-1 white--text': !isClosed && !isApproved }">
        {{ isClosed || isApproved ? "마감" : "승인대기" }}
    </div> -->
</template>

<script>
import { RENTAL_SCHEDULE_STATES } from "@/assets/variables";
import dayjs from "dayjs";
export default {
    props: {
        item: { type: Object, default: () => ({}) },
        date: { type: String },
        time: { type: Number },
        schedulesOnCloud: { type: Array, default: () => [] },
    },
    computed: {
        scheduleOnCloud() {
            return this.schedulesOnCloud.find((schedule) => schedule.time == this.time);
        },
        isClosed() {
            return dayjs(this.date).set("hour", this.time).isBefore(dayjs());
        },
        isApproved() {
            return this.scheduleOnCloud?.state == RENTAL_SCHEDULE_STATES.APPROVED.value;
        },
    },
};
</script>
